import * as React from 'react';
import Segment from '../../../DesktopFlightRoute/components/Segment/Segment';
import SegmentDelimiterItem from '../../../DesktopFlightRoute/components/SegmentDelimiterItem/SegmentDelimiterItem';
import cn from 'classnames';
import { ThemeProvider, useTheme } from '../../../theme';
import MediaQuery from '../../../MediaQuery/MediaQuery';
import { MobileSegmentUpgrade } from '../../../MobileSegmentInfo';
import { Flight, AviaSegmentGroup } from '../../store';
import { SegmentFragment, SegmentWithTransferFragment } from '@websky/graphql';
import { CheckinCard } from '@shared/CheckinCard';

export interface CheckoutSegmentProps {
	segment: SegmentFragment;
	parentFlight: Flight;
	index: number;
	highlight: boolean;
	transferInfo?: SegmentWithTransferFragment['transferDuration'];
	showStopsInfo: boolean;
}

export const SelectableCheckoutSegment: React.FC<CheckoutSegmentProps> = ({
	index,
	highlight,
	parentFlight,
	segment,
	transferInfo,
	showStopsInfo
}) => {
	const { SelectableSegment: css } = useTheme('UpgradeFlightClass');
	const checkoutFlight = parentFlight as AviaSegmentGroup;

	const segmentWithTransfer = {
		segment,
		transferDuration: showStopsInfo ? transferInfo : null
	};
	const isLast = index === checkoutFlight.segments.length - 1;
	const multipleSegments = checkoutFlight.segments.length > 1;

	return (
		<ThemeProvider
			value={{
				DesktopFlightRoute: {
					StopsInfoStyles: {
						stop: css.stopsInfo__stop,
						stop__label: cn({ [css.stopsInfo__label]: highlight })
					},
					RouteArrowStyles: {
						circle: cn({
							[css.selected]: highlight
						}),
						timeInRoute: cn(css.timeInRoute, {
							[css.selected]: highlight
						})
					}
				}
			}}
		>
			<MediaQuery minWidth={'mobile'}>
				<CheckinCard className={cn(css.checkinCard, { [css.selected]: highlight })}>
					<SegmentDelimiterItem
						segment={segmentWithTransfer}
						isLast={isLast}
						multipleSegments={multipleSegments}
					>
						<Segment
							first={index === 0}
							last={false}
							className={cn(css.segment, {
								[css.selected]: highlight,
								[css.transfer]: multipleSegments,
								[css.last]: index !== 0
							})}
							segment={segmentWithTransfer}
							stops={checkoutFlight.segments[index]?.stops || []}
							singleFlight={checkoutFlight.segments.length === 1}
							multipleSegments={multipleSegments}
						/>
					</SegmentDelimiterItem>
				</CheckinCard>
			</MediaQuery>
			<MediaQuery maxWidth={'mobile'}>
				<CheckinCard className={cn(css.checkinCard, { [css.selected]: highlight })}>
					<MobileSegmentUpgrade
						flightNumberClassName={cn(css.flightNumber, { [css.selected]: highlight })}
						showFullInfo={true}
						segments={[segmentWithTransfer]}
						className={cn(css.segment, { [css.selected]: highlight })}
						multipleSegments={multipleSegments}
						showAirplaneInfo={true}
						last={false}
					/>
				</CheckinCard>
			</MediaQuery>
		</ThemeProvider>
	);
};
